import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenWidth, getScreenIsReady } from 'selectors/screen'
import { getPagePath } from 'selectors/page'
import {
  getAlgoliaDataHitsResults,
  getAlgoliaDataPaginationCurrent,
  getAlgoliaDataPaginationTotal,
} from 'selectors/algolia2/data'
import { Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import {
  getNewThisWeekAlgoliaResults,
  getFeaturedSectionData,
  getCollectionTypes,
  getPageSlugifyDictionary,
  getDefaultCollectionType,
} from '../selectors/algolia'
import { Actions as AppActions } from '../actions'
const mapStateToProps = createStructuredSelector({
  collectionsList: getAlgoliaDataHitsResults,
  newThisWeekList: getNewThisWeekAlgoliaResults,
  featuredSectionData: getFeaturedSectionData,
  isReady: getScreenIsReady,
  screenWidth: getScreenWidth,
  collectionTypes: getCollectionTypes,
  pageSlugifyDictionary: getPageSlugifyDictionary,
  pagePath: getPagePath,
  defaultCollectionType: getDefaultCollectionType,
  currentPage: getAlgoliaDataPaginationCurrent,
  pageTotal: getAlgoliaDataPaginationTotal,
})

const mapDispatchToProps = (dispatch) => ({
  updateCollectionTypeUrl: (url: string) => dispatch(AppActions.NAVIGATE_TO_COLLECTION_TYPE(url)),
  loadMoreCollections: () => dispatch(AlgoliaDataActions.LOAD_MORE_DATA()),
})

export type ConnectorProps = {
  collectionsList: Record<string, any>
  newThisWeekList: Record<string, any>
  featuredSectionData: Record<string, any>
  isReady: boolean
  screenWidth: number
  updateCollectionTypeUrl: (...args: Array<any>) => any
  collectionTypes: Array<string>
  pageSlugifyDictionary: Record<string, any>
  pagePath: string
  defaultCollectionType: string
  loadMoreCollections: (...args: Array<any>) => any
  currentPage: number
  pageTotal: number
}
export default connect(mapStateToProps, mapDispatchToProps)